(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["up-brand-experience"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=scope=>{scope.querySelectorAll('[data-up-brand]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const tabs=[...root.querySelectorAll('[data-up-brand-tab]')],panels=[...root.querySelectorAll('[data-up-brand-panel]')];if(!tabs.length||tabs.length!==panels.length)return;root.classList.add('is-enhanced');root.querySelector('[data-up-brand-tabs]').setAttribute('role','tablist');tabs.forEach(tab=>tab.setAttribute('role','tab'));panels.forEach(panel=>{panel.setAttribute('role','tabpanel');panel.tabIndex=0});const show=(index,focus=false)=>{tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;panels[i].hidden=i!==index});if(focus)tabs[index].focus()};tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>show(index));tab.addEventListener('keydown',event=>{let target=index;if(event.key==='ArrowRight')target=(index+1)%tabs.length;else if(event.key==='ArrowLeft')target=(index-1+tabs.length)%tabs.length;else if(event.key==='Home')target=0;else if(event.key==='End')target=tabs.length-1;else return;event.preventDefault();show(target,true)})});show(0);root.addEventListener('shopify:block:select',event=>{const panel=event.target.closest('[data-up-brand-panel]');const i=panels.indexOf(panel);if(i>=0)show(i)})})};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);document.addEventListener('shopify:section:load',event=>init(event.target))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["up-client-marquee"] && !Shopify.designMode) return;
  try {
    
(()=>{const initialize=(scope=document)=>{scope.querySelectorAll('[data-up6-marquee]').forEach(section=>{if(section.dataset.ready)return;const track=section.querySelector('[data-up6-marquee-track]');const original=track?.firstElementChild;if(!original)return;const copy=original.cloneNode(true);copy.setAttribute('aria-hidden','true');copy.querySelectorAll('[id]').forEach(x=>x.removeAttribute('id'));copy.querySelectorAll('[data-shopify-editor-block]').forEach(x=>x.removeAttribute('data-shopify-editor-block'));track.append(copy);section.dataset.ready='true';const button=section.querySelector('[data-up6-marquee-toggle]');if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches){button.hidden=false;button.addEventListener('click',()=>{const paused=section.toggleAttribute('data-paused');button.setAttribute('aria-pressed',String(paused))})}})};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initialize(),{once:true});else initialize();document.addEventListener('shopify:section:load',e=>initialize(e.target))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["up-conversion-assist"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('up-conversion-assist')) return;
    const memory = new Set();
    const stored = (key) => {
      try { return sessionStorage.getItem(key) === '1' || memory.has(key); } catch (_) { return memory.has(key); }
    };
    const remember = (key) => {
      memory.add(key);
      try { sessionStorage.setItem(key, '1'); } catch (_) {}
    };
    class UpConversionAssist extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.bar = this.querySelector('[data-up-assist-bar]');
        this.dialog = this.querySelector('[data-up-assist-dialog]');
        this.inquiry = document.getElementById('start-project');
        this.hero = document.querySelector('[data-up-hero], .up6-hero, .up-hero');
        this.pageWrapper = document.querySelector('.page-wrapper');
        if (!this.bar || !this.inquiry || !this.hero) return;
        this.started = performance.now();
        this.maxScroll = 0;
        this.formEngaged = stored('up7-assist-engaged');
        this.committed = false;
        this.shown = false;
        this.desktop = window.matchMedia('(min-width: 900px) and (hover: hover) and (pointer: fine)');
        const on = (node, type, callback, options = {}) => node.addEventListener(type, callback, { ...options, signal: this.controller.signal });
        const price = this.querySelector('[data-up-assist-price]');
        if (price) {
          const amount = Number(this.dataset.price);
          const currency = this.dataset.currency;
          if (Number.isFinite(amount) && amount > 0 && /^[A-Z]{3}$/.test(currency)) {
            try { price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency, maximumFractionDigits: 2, minimumFractionDigits: amount % 1 ? 2 : 0 }).format(amount); } catch (_) {}
          }
        }
        on(window, 'scroll', () => this.schedule(), { passive: true });
        if (this.pageWrapper) on(this.pageWrapper, 'scroll', () => this.schedule(), { passive: true });
        on(window, 'resize', () => this.schedule(), { passive: true });
        on(window, 'pageshow', () => this.schedule());
        on(document, 'focusin', () => this.schedule());
        on(document, 'focusout', () => this.schedule());
        on(document, 'visibilitychange', () => this.schedule());
        on(this.inquiry, 'input', () => this.engage());
        on(this.inquiry, 'change', () => this.engage());
        on(this.inquiry, 'submit', () => { this.committed = true; this.engage(); }, { capture: true });
        on(this.querySelector('[data-up-assist-dismiss]'), 'click', () => {
          remember('up7-assist-dismissed');
          this.emit('action', 'sticky', 'dismiss');
          this.update();
        });
        on(document, 'click', (event) => {
          const link = event.target.closest?.('a');
          if (!link) return;
          const booking = this.dataset.bookingUrl;
          const bookingLink = booking && link.href === new URL(booking, location.href).href;
          if (bookingLink || link.matches('[data-up-booking]')) { this.committed = true; this.engage(); }
          if (!this.contains(link) || !link.dataset.upAssistAction) return;
          const surface = this.dialog?.contains(link) ? 'exit' : 'sticky';
          this.committed = true;
          this.engage();
          this.emit('action', surface, link.dataset.upAssistAction);
          if (this.dialog?.open) { this.returnFocus = null; this.dialog.close(); }
        }, { capture: true });
        if (this.dialog) {
          on(this.querySelector('[data-up-assist-dialog-close]'), 'click', () => this.closeDialog());
          on(this.dialog, 'cancel', () => this.emit('action', 'exit', 'dismiss'));
          on(this.dialog, 'close', () => {
            const previous = this.returnFocus;
            this.returnFocus = null;
            if (previous?.isConnected && previous !== document.body && previous.getClientRects().length) previous.focus({ preventScroll: true });
            this.schedule();
          });
          on(this.dialog, 'click', (event) => {
            if (event.target !== this.dialog) return;
            const rect = this.dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.closeDialog();
          });
          if (!window.Shopify?.designMode) on(document.documentElement, 'mouseleave', (event) => this.tryExit(event));
        }
        if ('IntersectionObserver' in window) {
          this.intersections = new IntersectionObserver(() => this.schedule());
          this.intersections.observe(this.hero);
          this.intersections.observe(this.inquiry);
        }
        this.mutations = new MutationObserver((records) => {
          if (records.some((record) => !this.contains(record.target))) this.schedule();
        });
        this.mutations.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'hidden', 'aria-hidden', 'aria-modal'] });
        if (window.visualViewport) on(window.visualViewport, 'resize', () => this.schedule(), { passive: true });
        this.update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.intersections?.disconnect();
        this.mutations?.disconnect();
        cancelAnimationFrame(this.frame);
        if (this.dialog?.open) this.dialog.close();
        if (this.bar) this.bar.hidden = true;
      }
      emit(type, surface, action = null) {
        this.dispatchEvent(new CustomEvent('up:assist', { bubbles: true, detail: { type, surface, action, sectionId: this.dataset.sectionId, priceConfirmed: this.dataset.priceConfirmed === 'true' } }));
      }
      engage() {
        this.formEngaged = true;
        remember('up7-assist-engaged');
        this.schedule();
      }
      schedule() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; if (this.isConnected) this.update(); });
      }
      inView(element) {
        const rect = element.getBoundingClientRect();
        return rect.bottom > 0 && rect.top < window.innerHeight;
      }
      modalOpen() {
        return Array.from(document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"], [data-up-booking-open="true"]')).some((element) => !element.hidden && element.getAttribute('aria-hidden') !== 'true' && element.getClientRects().length > 0);
      }
      formActive() {
        return Boolean(document.activeElement?.closest('form, input, textarea, select, [contenteditable="true"], iframe'));
      }
      captureScrollDepth() {
        const wrapper = this.pageWrapper;
        const wrapperScrolls = wrapper && /^(auto|scroll)$/.test(window.getComputedStyle(wrapper).overflowY) && wrapper.scrollHeight > wrapper.clientHeight;
        const page = document.scrollingElement || document.documentElement;
        const distance = wrapperScrolls ? wrapper.scrollHeight - wrapper.clientHeight : page.scrollHeight - window.innerHeight;
        const position = wrapperScrolls ? wrapper.scrollTop : window.scrollY;
        if (distance > 0) this.maxScroll = Math.max(this.maxScroll, Math.min(1, Math.max(0, position / distance)));
      }
      update() {
        this.captureScrollDepth();
        const visible = this.dataset.stickyEnabled === 'true' && !stored('up7-assist-dismissed') && !this.committed && !document.hidden && this.hero.getBoundingClientRect().bottom <= 0 && !this.inView(this.inquiry) && !this.formActive() && !this.modalOpen() && !this.inquiry.querySelector('.up-inquiry__success:not([hidden])');
        if (this.bar.hidden === visible) this.bar.hidden = !visible;
        if (visible && !this.shown) { this.shown = true; this.emit('show', 'sticky'); }
      }
      tryExit(event) {
        this.captureScrollDepth();
        if (event.clientY > 0 || event.relatedTarget || !this.desktop.matches || this.dataset.exitEnabled !== 'true' || stored('up7-assist-exit-seen') || stored('up7-assist-dismissed') || this.formEngaged || this.committed || document.hidden || performance.now() - this.started < 40000 || this.maxScroll < .35 || this.formActive() || this.modalOpen() || this.inView(this.inquiry) || this.inquiry.querySelector('.up-inquiry__success:not([hidden])')) return;
        if (typeof this.dialog?.showModal !== 'function') return;
        this.returnFocus = document.activeElement;
        try { this.dialog.showModal(); } catch (_) { this.returnFocus = null; return; }
        remember('up7-assist-exit-seen');
        this.emit('show', 'exit');
        this.update();
      }
      closeDialog() {
        if (!this.dialog?.open) return;
        this.emit('action', 'exit', 'dismiss');
        this.dialog.close();
      }
    }
    customElements.define('up-conversion-assist', UpConversionAssist);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["up-design-showcase"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=(scope=document)=>scope.querySelectorAll('[data-up6-gallery]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const track=root.querySelector('[data-up6-track]');const looks=[...root.querySelectorAll('[data-up6-look]')];root.querySelectorAll('[data-up6-filter]').forEach(button=>button.addEventListener('click',()=>{const sector=button.dataset.up6Filter;root.querySelectorAll('[data-up6-filter]').forEach(x=>x.setAttribute('aria-pressed',String(x===button)));looks.forEach(card=>card.hidden=sector!=='all'&&card.dataset.sector!==sector);root.querySelector('[data-up6-empty]').hidden=looks.some(x=>!x.hidden);track.scrollLeft=0}));const move=direction=>{const card=looks.find(x=>!x.hidden);if(!card)return;track.scrollBy({left:direction*(card.getBoundingClientRect().width+22),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})};root.querySelector('[data-up6-prev]').addEventListener('click',()=>move(-1));root.querySelector('[data-up6-next]').addEventListener('click',()=>move(1));track.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();move(event.key==='ArrowLeft'?-1:1)}})});if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});else init();document.addEventListener('shopify:section:load',e=>init(e.target))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["up-fabric-performance"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=(scope=document)=>{const sections=[...(scope.matches?.('[data-up-fabric]')?[scope]:[]),...scope.querySelectorAll('[data-up-fabric]')];sections.forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const track=root.querySelector('[data-up-fabric-track]');const move=direction=>{const card=track.querySelector('[data-up-fabric-card]');if(!card)return;const gap=parseFloat(getComputedStyle(track).gap)||0;track.scrollBy({left:direction*(card.getBoundingClientRect().width+gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})};root.querySelector('[data-up-fabric-prev]').addEventListener('click',()=>move(-1));root.querySelector('[data-up-fabric-next]').addEventListener('click',()=>move(1));track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1)}})})};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});else init();document.addEventListener('shopify:section:load',e=>init(e.target))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["up-featured-work"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope = document) => {
      scope.querySelectorAll('[data-up-featured-work]').forEach((section) => {
        if (section.dataset.upWorkReady) return;
        section.dataset.upWorkReady = 'true';
        const dialog = section.querySelector('[data-up-work-dialog]');
        const closeButton = section.querySelector('[data-up-work-close]');
        if (!dialog || !closeButton) return;
        let lastTrigger = null;
        let scrollState = null;
        const restore = () => {
          if (scrollState) {
            scrollState.forEach(({ element, overflow }) => { element.style.overflow = overflow; });
            scrollState = null;
          }
          if (lastTrigger?.isConnected) lastTrigger.focus({ preventScroll: true });
          lastTrigger = null;
        };
        section.querySelectorAll('[data-up-work-open]').forEach((trigger) => {
          trigger.addEventListener('click', (event) => {
            if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || typeof dialog.showModal !== 'function') return;
            event.preventDefault();
            if (dialog.open) return;
            lastTrigger = trigger;
            const scrollers = [document.documentElement, document.querySelector('.page-wrapper')].filter(Boolean);
            scrollState = scrollers.map((element) => ({ element, overflow: element.style.overflow }));
            dialog.showModal();
            scrollers.forEach((element) => { element.style.overflow = 'hidden'; });
            closeButton.focus({ preventScroll: true });
          });
        });
        closeButton.addEventListener('click', () => dialog.close());
        dialog.addEventListener('cancel', (event) => { event.preventDefault(); dialog.close(); });
        dialog.addEventListener('close', restore);
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          const outside = event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
          if (outside) dialog.close();
        });
      });
    };
    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-up-work-dialog][open]').forEach((dialog) => dialog.close());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["up-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{const menu=document.querySelector('.up-menu');if(!menu)return;if(event.target.closest('.up-menu-panel a')||!menu.contains(event.target))menu.removeAttribute('open')});
document.addEventListener('keydown',event=>{if(event.key==='Escape'){const menu=document.querySelector('.up-menu[open]');if(menu){menu.removeAttribute('open');menu.querySelector('summary').focus()}}});
(() => {
  const carryCampaign = () => {
    const parameters = new URLSearchParams(window.location.search);
    const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
    const campaign = keys.map(key => [key, (parameters.get(key) || '').replace(/[\u0000-\u001f\u007f]/g, '').trim().slice(0, 180)]).filter(([, value]) => value);
    if (!campaign.length) return;
    document.querySelectorAll('[data-up-service-page]').forEach(link => {
      const url = new URL(link.getAttribute('href'), window.location.href);
      if (url.origin !== window.location.origin) return;
      campaign.forEach(([key, value]) => url.searchParams.set(key, value));
      link.href = url.pathname + url.search + url.hash;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', carryCampaign, {once: true});
  else carryCampaign();
  document.addEventListener('shopify:section:load', carryCampaign);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["up-inquiry"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pendingKey = 'up-inquiry-pending';
    const pendingMaxAge = 30 * 60 * 1000;
    const isolateSubmission = (section) => {
      const form = section.querySelector('form');
      const success = section.querySelector('[data-up-inquiry-success]');
      const body = section.querySelector('[data-up-inquiry-body]');
      const errors = section.querySelector('.up-inquiry__errors');
      if (!form || !success || !body) return;
      let anchor = window.location.hash.slice(1);
      try { anchor = decodeURIComponent(anchor); } catch {}
      const otherForm = anchor && document.getElementById(anchor);
      const foreignOrigin = anchor !== form.id && (/^Up(?:Quiz|Inquiry)-/.test(anchor) || otherForm instanceof HTMLFormElement);
      let pending = null;
      try {
        pending = JSON.parse(sessionStorage.getItem(pendingKey) || 'null');
        const age = Date.now() - pending?.timestamp;
        if (!pending || !Number.isFinite(age) || age < 0 || age > pendingMaxAge) {
          pending = null;
          sessionStorage.removeItem(pendingKey);
        }
      } catch {}
      const matchingPending = pending?.formId === form.id && pending?.path === window.location.pathname;
      const ownsSubmission = anchor === form.id || (!foreignOrigin && matchingPending);
      const confirmed = success.dataset.nativeSuccess === 'true' && ownsSubmission;
      success.hidden = !confirmed;
      body.hidden = confirmed;
      if (errors && foreignOrigin) {
        errors.hidden = true;
        form.querySelectorAll('[aria-invalid="true"]').forEach((input) => {
          input.removeAttribute('aria-invalid');
          const descriptions = (input.getAttribute('aria-describedby') || '').split(/\s+/).filter((id) => id && id !== errors.id);
          if (descriptions.length) input.setAttribute('aria-describedby', descriptions.join(' '));
          else input.removeAttribute('aria-describedby');
        });
      }
      if (success.dataset.nativeSuccess === 'true' || errors) {
        try { sessionStorage.removeItem(pendingKey); } catch {}
      }
      section.upInquiryShowForm = () => {
        body.hidden = false;
        success.hidden = true;
      };
    };
    const selectValue = (select, value) => {
      if (!select || !value || !Array.from(select.options).some((option) => option.value === value)) return false;
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    };
    const routeService = (section, value) => section.dataset.upTwoRoutes === 'true' && value === 'custom' ? 'signature' : value;
    const selectService = (section, value) => {
      value = routeService(section, value);
      const select = section.querySelector('[data-up-service-select]');
      if (select) return selectValue(select, value);
      const radio = Array.from(section.querySelectorAll('[data-up-service-input]')).find((input) => input.value === value);
      if (!radio) return false;
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    };
    const initialize = (scope = document) => {
      const sections = [...(scope.matches?.('[data-up-inquiry]') ? [scope] : []), ...scope.querySelectorAll('[data-up-inquiry]')];
      sections.forEach((section) => {
        if (section.dataset.upReady === 'v7') return;
        section.dataset.upReady = 'v7';
        isolateSubmission(section);
        const parameters = new URLSearchParams(window.location.search);
        const serviceSelect = section.querySelector('[data-up-service-select]');
        const industrySelect = section.querySelector('[data-up-industry-input]');
        const intentSelect = section.querySelector('[data-up-intent-input]');
        const context = section.querySelector('[data-up-context]');
        const contextText = section.querySelector('[data-up-context-text]');
        const updateContext = () => {
          if (!context || !contextText) return;
          const labels = [];
          if (serviceSelect && serviceSelect.value !== 'unsure') labels.push(serviceSelect.selectedOptions[0].textContent.trim());
          if (intentSelect && intentSelect.value !== 'project') labels.push(intentSelect.selectedOptions[0].textContent.trim());
          if (industrySelect?.value) labels.push(industrySelect.selectedOptions[0].textContent.trim());
          contextText.textContent = labels.join(' · ');
          context.hidden = labels.length === 0;
        };
        const updateIntent = () => {
          section.querySelectorAll('[data-up-intent-hint]').forEach((hint) => { hint.hidden = hint.dataset.upIntentHint !== intentSelect?.value; });
          const prompt = section.querySelector('[data-up-compact-prompt]');
          if (prompt) {
            const text = intentSelect?.value === 'sample' ? prompt.dataset.upPromptSample : intentSelect?.value === 'reorder' ? prompt.dataset.upPromptReorder : '';
            prompt.textContent = text || '';
            prompt.hidden = !text;
          }
          updateContext();
        };
        serviceSelect?.addEventListener('change', updateContext);
        industrySelect?.addEventListener('change', updateContext);
        intentSelect?.addEventListener('change', updateIntent);
        selectService(section, parameters.get('service'));
        selectValue(industrySelect, parameters.get('industry'));
        selectValue(intentSelect, parameters.get('intent'));
        updateIntent();
        const editContext = section.querySelector('[data-up-edit-context]');
        if (editContext) {
          editContext.hidden = false;
          editContext.addEventListener('click', () => {
            const details = section.querySelector('[data-up-optional-details]');
            if (details) details.open = true;
            serviceSelect?.focus({ preventScroll: true });
          });
        }
        section.querySelectorAll('[data-up-utm]').forEach((input) => {
          const value = (parameters.get(input.dataset.upUtm) || '').replace(/[\u0000-\u001f\u007f]/g, '').trim().slice(0, 180);
          input.value = value;
          input.disabled = !value;
        });
        const steps = Array.from(section.querySelectorAll('[data-up-form-step]'));
        const showStep = (step, moveFocus = false) => {
          steps.forEach((panel) => { panel.hidden = panel.dataset.upFormStep !== String(step); });
          section.querySelectorAll('[data-up-progress-step]').forEach((item) => {
            if (item.dataset.upProgressStep === String(step)) item.setAttribute('aria-current', 'step');
            else item.removeAttribute('aria-current');
          });
          if (moveFocus) {
            const target = step === 2 ? section.querySelector('[data-up-details-title]') : section.querySelector('[data-up-service-input]:checked');
            target?.focus({ preventScroll: true });
          }
        };
        section.upInquiryShowStep = showStep;
        if (steps.length === 2) {
          section.querySelectorAll('[data-up-progress], [data-up-next], [data-up-back], [data-up-continue-note]').forEach((control) => { control.hidden = false; });
          section.querySelector('[data-up-next]')?.addEventListener('click', () => showStep(2, true));
          section.querySelector('[data-up-back]')?.addEventListener('click', () => showStep(1, true));
          section.querySelector('form')?.addEventListener('invalid', (event) => {
            const panel = event.target.closest('[data-up-form-step]');
            if (panel) showStep(Number(panel.dataset.upFormStep));
          }, true);
          showStep(section.querySelector('.up-inquiry__errors:not([hidden])') ? 2 : 1);
        }
        section.querySelectorAll('[data-up-request-call]').forEach((button) => {
          button.addEventListener('click', (event) => {
            const form = button.form;
            if (!form || typeof form.requestSubmit !== 'function') return;
            event.preventDefault();
            button.value = 'discovery_call';
            form.requestSubmit(button);
          });
        });
        const status = section.querySelector('[data-up-inquiry-status]:not([hidden])');
        if (status) requestAnimationFrame(() => { if (status.isConnected && !status.hidden) status.focus(); });
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    else initialize();
    if (document.documentElement.dataset.upInquiryEvents === 'v7') return;
    document.documentElement.dataset.upInquiryEvents = 'v7';
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || form.elements.namedItem('form_type')?.value !== 'contact') return;
      try {
        if (form.closest('[data-up-inquiry]')) {
          sessionStorage.setItem(pendingKey, JSON.stringify({ formId: form.id, path: window.location.pathname, timestamp: Date.now() }));
        } else sessionStorage.removeItem(pendingKey);
      } catch {}
    }, true);
    document.addEventListener('click', (event) => {
      const trigger = event.target instanceof Element ? event.target.closest('[data-up-service], [data-up-industry], [data-up-intent]') : null;
      if (!trigger || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || trigger.hasAttribute('download') || trigger.getAttribute('target') === '_blank') return;
      const section = document.querySelector('[data-up-inquiry]');
      if (!section) return;
      const radio = Array.from(section.querySelectorAll('[data-up-service-input]')).find((input) => input.value === routeService(section, trigger.dataset.upService));
      const serviceChanged = selectService(section, trigger.dataset.upService);
      const industrySelect = section.querySelector('[data-up-industry-input]');
      const intentSelect = section.querySelector('[data-up-intent-input]');
      const industryChanged = selectValue(industrySelect, trigger.dataset.upIndustry);
      const intentChanged = selectValue(intentSelect, trigger.dataset.upIntent || (serviceChanged ? 'project' : undefined));
      if (!serviceChanged && !industryChanged && !intentChanged) return;
      event.preventDefault();
      section.upInquiryShowForm?.();
      section.upInquiryShowStep?.(1);
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      section.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
      const compactTarget = trigger.dataset.upIntent && trigger.dataset.upIntent !== 'project' ? section.querySelector('[data-up-compact-brief]') : section.querySelector('[name="contact[name]"]');
      const target = section.dataset.upCompact === 'true' ? compactTarget : trigger.dataset.upIntent && intentChanged ? intentSelect : radio || industrySelect || intentSelect;
      target?.focus({ preventScroll: true });
    });
  })();

(() => {
  const sync = () => {
    const calculator = document.querySelector('[data-up-calculator][data-up-calculator-used="true"]');
    document.querySelectorAll('[data-up-calculator-context]').forEach(input => {
      if (!calculator) { input.disabled = true; return; }
      const summary = calculator.dataset.upCalculatorSummary || '';
      const status = calculator.querySelector('.up-calc__status')?.textContent.trim() || '';
      input.value = (status+'. '+calculator.dataset.upCalculatorTeamSize+' people; '+calculator.dataset.upCalculatorShirtsPerPerson+' shirts/person; '+calculator.dataset.pricePerShirt+'/shirt. '+summary).slice(0,850);
      input.disabled = !summary;
    });
  };
  document.addEventListener('input', event => { const calculator = event.target.closest?.('[data-up-calculator]'); if (calculator) { calculator.dataset.upCalculatorUsed = 'true'; sync(); } });
  document.addEventListener('click', event => { const link = event.target.closest?.('[data-up-calculator] a[href="#start-project"]'); if (link) { link.closest('[data-up-calculator]').dataset.upCalculatorUsed = 'true'; sync(); } });
  document.addEventListener('up:calculator', sync);
  document.addEventListener('submit', event => { if (event.target.closest?.('[data-up-inquiry]')) sync(); }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["up-product-guides"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.upGuideInquiryBound) return;
    window.upGuideInquiryBound = true;
    document.addEventListener('click', (event) => {
      const trigger = event.target instanceof Element ? event.target.closest('a[data-up-guide-title]') : null;
      if (!trigger || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || trigger.hasAttribute('download') || (trigger.target && trigger.target !== '_self')) return;
      const title = trigger.dataset.upGuideTitle?.trim();
      const form = document.querySelector('[data-up-inquiry] form');
      if (!title || !form) return;
      let interest = form.querySelector('input[type="hidden"][name="contact[Product interest]"]');
      if (!interest) {
        interest = document.createElement('input');
        interest.type = 'hidden';
        interest.name = 'contact[Product interest]';
        form.append(interest);
      }
      interest.value = title;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["up-team-calculator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope = document) => {
      const sections = [...(scope.matches?.('[data-up-calculator]') ? [scope] : []), ...scope.querySelectorAll('[data-up-calculator]')];
      sections.forEach((section) => {
        if (section.dataset.upCalculatorReady) return;
        const fieldset = section.querySelector('[data-up-calc-inputs]');
        const announcement = section.querySelector('[data-up-calc-announcement]');
        const fields = [...section.querySelectorAll('[data-up-calc-field]')].map((field) => ({ key: field.dataset.upCalcField, number: field.querySelector('[data-up-calc-number]'), range: field.querySelector('[data-up-calc-range]') }));
        if (!fieldset || fields.length !== 2 || fields.some((field) => !field.number || !field.range)) return;
        const state = Object.fromEntries(fields.map((field) => [field.key, Math.round(Number(field.number.value))]));
        const pricePerShirtCents = Number(section.dataset.pricePerShirtCents);
        if (!Number.isSafeInteger(pricePerShirtCents) || pricePerShirtCents < 0) return;
        const currency = section.dataset.currency || 'USD';
        const locale = document.documentElement.lang || 'en';
        let formatter;
        try { formatter = new Intl.NumberFormat(locale, { style: 'currency', currency, currencyDisplay: 'code', minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
        catch { formatter = new Intl.NumberFormat('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
        const numericMoney = (value) => formatter.formatToParts(value).filter((part) => part.type !== 'currency' && part.type !== 'literal').map((part) => part.value).join('');
        const dollarMoney = (value) => '$' + numericMoney(value);
        const fullMoney = (value) => currency + ' ' + dollarMoney(value);
        let announcementTimer;
        const setOutput = (key, value) => { const output = section.querySelector('[data-up-calc-output="' + key + '"]'); if (output) output.textContent = value; };
        const render = (announce = true) => {
          const annualPerPersonCents = pricePerShirtCents * state.shirts;
          const teamTotalCents = annualPerPersonCents * state.team;
          const annualPerPerson = annualPerPersonCents / 100;
          const weeklyPerPerson = annualPerPersonCents / 5200;
          const monthlyPerPerson = annualPerPersonCents / 1200;
          const teamTotal = teamTotalCents / 100;
          setOutput('week', dollarMoney(weeklyPerPerson));
          setOutput('month', dollarMoney(monthlyPerPerson));
          setOutput('year', dollarMoney(annualPerPerson));
          setOutput('team', dollarMoney(teamTotal));
          setOutput('garments', String(state.team * state.shirts));
          setOutput('people', String(state.team));
          fields.forEach((field) => {
            const minimum = Number(field.range.min);
            const maximum = Number(field.range.max);
            const displayValue = state[field.key];
            const progress = maximum > minimum ? (displayValue - minimum) / (maximum - minimum) * 100 : 100;
            field.range.style.setProperty('--up-calc-progress', progress + '%');
          });
          const values = { week: fullMoney(weeklyPerPerson), month: fullMoney(monthlyPerPerson), year: fullMoney(annualPerPerson), team: fullMoney(teamTotal) };
          const summary = (announcement?.dataset.template || '').replace(/\[(week|month|year|team)\]/g, (_, key) => values[key]);
          section.dataset.upCalculatorSummary = summary;
          section.dataset.pricePerShirt = fullMoney(pricePerShirtCents / 100);
          section.dataset.upCalculatorTeamSize = String(state.team);
          section.dataset.upCalculatorShirtsPerPerson = String(state.shirts);
          section.dispatchEvent(new CustomEvent('up:calculator', { bubbles: true, detail: { teamSize: state.team, shirtsPerPerson: state.shirts, pricePerShirt: pricePerShirtCents / 100, pricePerShirtCents, currency, priceConfirmed: section.dataset.priceConfirmed === 'true', annualPerPerson, annualPerPersonCents, weeklyPerPerson, monthlyPerPerson, teamTotal, teamTotalCents, summary } }));
          window.clearTimeout(announcementTimer);
          if (announce && announcement) announcementTimer = window.setTimeout(() => { announcement.textContent = summary; }, 450);
        };
        fields.forEach((field) => {
          const update = (input, commit = false) => {
            const minimum = Math.round(Number(input.min));
            const maximum = Math.round(Number(input.max));
            const entered = input.value === '' ? NaN : Number(input.value);
            const valid = Number.isFinite(entered) && Math.abs(entered - Math.round(entered)) < 0.000001 && Math.round(entered) >= minimum && Math.round(entered) <= maximum;
            if (!valid && !commit) return;
            const value = Math.max(minimum, Math.min(maximum, Math.round(Number.isFinite(entered) ? entered : state[field.key])));
            state[field.key] = value;
            field.range.value = String(value);
            if (input === field.range || commit) field.number.value = String(value);
            render();
          };
          field.range.addEventListener('input', () => update(field.range));
          field.number.addEventListener('input', () => update(field.number));
          field.number.addEventListener('change', () => update(field.number, true));
          field.number.addEventListener('blur', () => update(field.number, true));
        });
        section.upCalculatorCleanup = () => window.clearTimeout(announcementTimer);
        section.dataset.upCalculatorReady = 'true';
        fieldset.disabled = false;
        render(false);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    else initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const sections = [...(event.target.matches?.('[data-up-calculator]') ? [event.target] : []), ...event.target.querySelectorAll('[data-up-calculator]')];
      sections.forEach((section) => section.upCalculatorCleanup?.());
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
